<button class="close" mat-icon-button [mat-dialog-close]>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <p></p>
</div>
